import authReducer from "./reducer"

const reducer = {
  reducers: authReducer
}

export default reducer